import api from '../libs/axios';

export const getCompanyInfo = async (params, signal) => {
  const response = await api.get('/company', {
    params,
    signal,
  });
  return response.data;
};

export const updateCompanyInfo = async (params, dto, signal) => {
  const response = await api.patch('/company', dto, {
    params,
    signal,
  });
  return response.data;
};

export const transferCompanyMember = async (dto, signal) => {
  const response = await api.post('/company/transfer/member', dto, {
    signal,
  });
  return response.data;
};

export const getShippingHistory = async (params) => {
  const response = await api.get('/shipping_history', { params });
  return response.data;
};

export const createEvaluation = async (dto) => {
  const response = await api.post('/send_evaluation', dto);
  return response.data;
};

export const getEvaluationList = async () => {
  const response = await api.get('/list_evaluation');
  return response.data;
};

export const getUserEvaluationList = async (params) => {
  const response = await api.get('/list_user_evaluation', { params });
  return response.data;
};

export const addCompanyMember = async (dto) => {
  const response = await api.post('/company_add_member', dto);
  return response.data;
};

export const getCouponList = async (params, signal) => {
  const response = await api.get('/company/coupon', { params, signal });
  return response.data;
};

export const activateCompanyCoupon = async (dto) => {
  const response = await api.post('/company/coupon', dto);
  return response.data;
};

export const createCompany = async (dto) => {
  const response = await api.post('/company', dto);
  return response.data;
};

export const importCompany = async (params, payload) => {
  const response = await api.post('/company', payload, {
    params,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const importPoint = async (params, payload) => {
  const response = await api.post('/company/import/point', payload, {
    params,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};
